import { render, staticRenderFns } from "./SliderMini.vue?vue&type=template&id=2afce69c&"
import script from "./SliderMini.vue?vue&type=script&lang=js&"
export * from "./SliderMini.vue?vue&type=script&lang=js&"
import style0 from "./SliderMini.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports